var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"code-bg px-4 mb-0 text-white"},[_vm._v("      "),_vm._l((_vm.lines),function(line,number){return _c('p',{staticClass:"mb-0",class:{'highlight': number == _vm.highlightedLine}},[_c('span',{staticClass:"mr-4"},[_vm._v(_vm._s(number))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(line))])])}),_vm._v("\n  ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }